import { workOrderStatuses, workOrderStatusList } from "../consts";
import WorkorderButton from "./WorkorderButton";
import { workorderApprovalStyle } from "../style";

const WorkorderButtons = ({ isPendingApproval, setIsPendingApproval, NACount, PACount, pendingLoads, loadsOnly, listDialogClientId, listDialogClientAccountId }) => {
    const classes = workorderApprovalStyle();

    return <div className={classes.filterContainer}>
        {!loadsOnly && <WorkorderButton
            onClick={() => setIsPendingApproval(false)}
            name={workOrderStatusList[workOrderStatuses.RequiredAttention]?.name}
            color={workOrderStatusList[workOrderStatuses.RequiredAttention]?.color}
            active={!isPendingApproval}
            count={NACount}
        />}
        <WorkorderButton
            onClick={() => setIsPendingApproval(true)}
            name={workOrderStatusList[workOrderStatuses.PendingApproval]?.name}
            color={workOrderStatusList[workOrderStatuses.PendingApproval]?.color}
            active={isPendingApproval}
            count={PACount}
            activityListDialog={true}
            pendingLoads={pendingLoads}
            loadsOnly={loadsOnly}
            clientId={listDialogClientId}
            clientAccountId={listDialogClientAccountId}
        />
    </div>
}
export default WorkorderButtons;